import React, {ReactElement, Suspense} from "react";
import {ApolloClient, ApolloProvider, InMemoryCache} from "@apollo/client";
import {Auth0Provider} from "@auth0/auth0-react";
import {setContext} from "@apollo/client/link/context";
import {render} from "react-dom";
import {BrowserRouter} from "react-router-dom";
import {createUploadLink} from "apollo-upload-client";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import App from "./App";
import {config} from "./config";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import {LoadingPage} from "components/loading-page";


const rootElement = document.getElementById("root");

const Setup = (): ReactElement => {
	if (process.env.REACT_APP_STAGE !== "development") {
		LogRocket.init(config.logRocketEnvironmentId);
		setupLogRocketReact(LogRocket);
	}

	const uploadLink = createUploadLink({
		uri: `${config.apiHost}/graphql`,
		credentials: "include",
	});

	const csrfTokenLink: any = setContext((_, {headers}) => {
		return {
			headers: {
				...headers,
				"x-csrf-token": localStorage.getItem("csrfToken") || "",
			},
		};
	});
	const client = new ApolloClient({
		link: csrfTokenLink.concat(uploadLink),
		cache: new InMemoryCache(),
	});

	if (client === undefined) {
		return (
			<div>Loading...</div>
		);
	}

	return (
		<ApolloProvider client={client}>
			<BrowserRouter>
				<Auth0Provider
					domain={config.auth0Domain}
					clientId={config.auth0ClientId}
				>
					<Suspense fallback={<LoadingPage />}>
						<App />
					</Suspense>
				</Auth0Provider>
			</BrowserRouter>
		</ApolloProvider>
	);
};

render(
	<Setup />,
	rootElement,
);

serviceWorkerRegistration.register();
